
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.274.989L.468 8.795a2.18 2.18 0 00.323 3.03l5.885 5.884a2.18 2.18 0 003.03.323l7.805-7.806c.355-.365.531-.869.48-1.376l-.406-5.542A2.679 2.679 0 0015.192.915L9.65.51a1.727 1.727 0 00-1.376.48zm4.48 6.077c-.35 0-.683-.143-.924-.396a1.275 1.275 0 010-1.848 1.306 1.306 0 011.848 1.848c-.241.253-.575.396-.924.396z","fill":"#7B01B5"}})])
          )
        }
      }
    